var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 988.96 200.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7a902;}.cls-2{fill:#313bac;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.13,390.56l-104-47.91V321.42l77.82-34.57v21.93l-54.88,22v2.45l82.27,36.24Zm-19.28,20.36L166.45,253h19.91L123.69,410.92Zm86.66-34.14V354.85l53.76-21.59v-2.45L162.63,295V273.33l105,48.09v21.23Z",
    transform: "translate(-19.11 -252.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M295.15,405.82l41.27-142.94H369L410.3,405.82H381.62l-28-108h-1.81l-28,108ZM316,378.74V354.18h72.48v24.56Z",
    transform: "translate(-19.11 -252.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M429.56,405.82V299.11h24.36l2.92,22.55v84.16Zm63.11,0V343.1q0-9.66-4-14.89T477.38,323q-20.55,0-20.54,29.6l-6.24-34.13h8.86q1.5-10.77,7.34-16.05t17.72-5.29q16.92,0,26.17,10.27t9.26,29v69.46Z",
    transform: "translate(-19.11 -252.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M581.29,407.83q-15.21,0-23.56-10t-8.35-28.23V299.11h27.28v63.72q0,9.17,4.17,14.15t11.53,5q9.55,0,14.44-7.4t4.89-24.81l5.43,35.53h-8.25q-2.52,10.88-9.77,16.71T581.29,407.83Zm30.4-32.21V299.11H639v70.47Zm1.81,31.2-1.81-25.57V362.53H639v18.93l14.69,2.21v22.15Z",
    transform: "translate(-19.11 -252.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M664.76,405.82V382.46h74.7v23.36Zm4-83.35V299.11h40.26l2,23.36Zm18.52,83.35V299.11h23.15l4,30.61v76.1Zm27.18-45.91-6.24-36.74h9.16Q719,297.1,744.69,297.1q15.19,0,23.3,11.17t8.11,32.22H749q0-9.47-3.48-13.59t-11.22-4.13q-10,0-14.9,9.66T714.49,359.91Z",
    transform: "translate(-19.11 -252.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M824.34,407.83q-17,0-26.47-8.36t-9.46-23.75q0-17.93,12.38-27.48t35.13-9.57a110.29,110.29,0,0,1,15.15.91A90.88,90.88,0,0,1,864,342.4l-4.43,21.24A64.22,64.22,0,0,0,848,361.88q-5.14-.25-10.77-.26-21.15,0-21.14,12.08a9.74,9.74,0,0,0,3.82,8.31q3.83,2.87,11.18,2.87,8.85,0,14.79-3.32a22.92,22.92,0,0,0,8.91-8.46,20.83,20.83,0,0,0,3-10.57v-6.64l3.83,27.38H853l3.52-3.22q-.3,9.26-4.22,15.45a24,24,0,0,1-11,9.26A42.64,42.64,0,0,1,824.34,407.83Zm36.14-1-2.32-31.61-.4-13.89V340.49q0-8.57-7.3-12.54t-21.69-4.37l-27.28-.71,2-24.76,23.26.3q29,.4,43.08,11.42T883.93,342v39.46l14.8,2.21v22.15Z",
    transform: "translate(-19.11 -252.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M952.31,407.83q-19.83,0-30.85-14.29t-11-41q0-26.47,11-41t31-14.5q12.18,0,18.47,5.29t8.21,16.05H987l-6.24,34.13q0-15.51-5.18-22.65T960,322.77q-10,0-15.4,7.8t-5.44,22q0,14.69,5.29,22.14T960,382.16q11.68,0,16.26-7.05t4.58-22.54l7.25,33.92h-9.47q-1.61,10.67-8.35,16T952.31,407.83Zm-31.51,46.1-1-23.75,34.22-1q14.1-.41,20.44-7.8t6.34-21.8V321.66l2-22.55h25.27v97.24q0,28.48-13.39,42T952,452.92Z",
    transform: "translate(-19.11 -252.98)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7791d7c88cdb2849adc220cae6bbac7e.svg";
export { ForwardRef as ReactComponent };